export default [
  {
    $el: 'div',
    children: [
      {
        $el: 'div',
        attrs: {
          class: 'flex flex-col gap-y-3 mb-3',
        },
        children: [
          {
            '$formkit': 'text',
            'name': 'email',
            'validation-label': 'Email',
            'validation': 'required|email',
            'placeholder': 'Enter your email address',
            'label': 'Email',
          },
          {
            $el: 'div',
            children: [
              {
                '$formkit': 'password',
                'name': 'password',
                'placeholder': 'Enter your password',
                'validation-label': 'Password',
                'validation': 'required',
                'label': 'Password',
              },
              {
                $el: 'p',
                attrs: {
                  class: 'mt-2 text-xs text-info hover:underline cursor-pointer float-right',
                  onClick: '$showPasswordRest',
                },
                children: ['Forgot password?'],
              },
            ],
          },
        ],
      },
    ],
  },
];
